import { useFormContext, Controller } from "react-hook-form";
import { TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DatePicker, useDateForQueryParams } from "components/DatePicker";

import { TInstallForm } from "../../../../hooks/useInstallForm";
import { MapLocationPicker_v2 } from "components/MapLocationPicker_v2";

const Step2 = () => {
  const { control } = useFormContext<TInstallForm>();
  const { t } = useTranslation();
  const [convertDateForQueryParam] = useDateForQueryParams();

  return (
    <div className="flex flex-col gap-4 h-full">
      <Typography className={"font-bold text-md"}>
        {t("installationInfo")}
      </Typography>
      <Controller
        name="installationDate"
        control={control}
        rules={{ required: t("dateIsRequired") }}
        render={({ field, fieldState }) => (
          <DatePicker
            {...field}
            callback={(res) => {
              field.onChange(convertDateForQueryParam(res));
            }}
            defaultValueDate={field.value}
            showDefaultDate={false}
            defaultError={Boolean(fieldState.error)}
            label={t("installationDate")}
          />
        )}
      />
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <TextField {...field} label={t("description")} multiline rows={3} />
        )}
      />
      <Controller
        name="location"
        control={control}
        render={({ field }) => (
          <div
            className={"w-full flex-1 flex-grow"}
            style={{ border: "1px solid red" }}
          >
            <MapLocationPicker_v2
              className={"w-full h-full"}
              onLocationPick={(coordinate) => {
                field.onChange(coordinate);
              }}
              showAddress
            />
          </div>
        )}
      />
    </div>
  );
};

export default Step2;
